module.exports = __webpack_public_path__ + "media/bark04.ce6286b9.mp3";